import React, { createContext, useContext } from "react";

const SiteContext = createContext(null);

/**
 * Wraps the entire app (via gatsby-browser.js / gatsby-ssr.js wrapRootElement).
 * Provides siteConfig and theme to any component via useSite().
 */
export function SiteProvider({ siteConfig, theme, content, services, locations, guides, youtube, templates, svgImageTemplate, children }) {
  return (
    <SiteContext.Provider value={{ siteConfig, theme, content, services, locations, guides, youtube, templates, svgImageTemplate }}>
      {children}
    </SiteContext.Provider>
  );
}

/** Hook — use in any component to access site config and theme. */
export function useSite() {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used within a SiteProvider");
  return ctx;
}
